import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { GeckoToastService } from 'ui';

import './index.scss';
import Action from './Action';

class AddActions extends Component {
  static propTypes = {
    value: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        value: PropTypes.any,
      })
    ),
    onChange: PropTypes.func,
    trigger: PropTypes.string,
  };

  static defaultProps = {
    value: [{}],
  };

  anyUnfinishedActions() {
    if (!this.props.value || !this.props.value.length) {
      return false;
    }
    return !!this.props.value.find((action) => {
      return (
        action.value === undefined ||
        (Array.isArray(action.value) && !action.value.length) ||
        (action.type === 'prechat_message' &&
          (!action.value.message || !action.value.sender)) ||
        (action.type === 'prechat_prompt' && !action.value)
      );
    });
  }

  addAction() {
    if (!this.props.trigger) {
      return;
    }
    if (this.anyUnfinishedActions()) {
      return new GeckoToastService().error(
        'You must finish configuring your previous Actions before adding a new one'
      );
    }
    this.props.onChange(this.props.value.concat([{}]));
  }

  addActionButton() {
    return (
      <div
        className={`Steps-ActionWorkflow-add-action gecko-btn gecko-ui-material btn btn-default ${
          !this.props.trigger || this.anyUnfinishedActions()
            ? 'Steps-ActionWorkflow-add-action-disabled'
            : ''
        }`}
        onClick={this.addAction.bind(this)}
      >
        <i className="far fa-plus"></i> Add Action
      </div>
    );
  }

  render() {
    return (
      <div className="Steps-ActionWorkflow">
        {this.props.value.map((action, index) => {
          const onChange = (newValue) => {
            const newActions = this.props.value.map((a, i) => {
              if (index === i) {
                return newValue;
              }
              return a;
            });
            this.props.onChange(newActions);
          };
          const removeAction = () => {
            const newActions = this.props.value.filter((_action, i) => {
              return i !== index;
            });
            if (newActions.length === 0) {
              return this.props.onChange([{}]);
            }
            this.props.onChange(newActions);
          };
          return (
            <Action
              trigger={this.props.trigger}
              value={action}
              onChange={onChange.bind(this)}
              removeAction={removeAction}
              key={index}
            />
          );
        })}
        {!this.props.trigger ? (
          <div className="ConfirmSetLive-Warning">
            <p>
              <i class="fas fa-exclamation-triangle"></i> You must select a
              Trigger in Step 2 before adding Actions
            </p>
          </div>
        ) : null}
        {this.addActionButton()}
      </div>
    );
  }
}

export default AddActions;
